var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9998 6.19663V33.804C40.9998 37.2255 38.1561 40 34.6475 40H6.35237C2.8441 40 0 37.2255 0 33.804V6.19663C0 2.77482 2.8441 0.000339508 6.35237 0.000339508H34.6475C38.1561 0.000339508 40.9998 2.77482 40.9998 6.19663Z",
    fill: "#007683"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7498 33.804V6.19663C40.7498 2.9187 38.0239 0.25034 34.6475 0.25034H6.35237C2.97628 0.25034 0.25 2.91871 0.25 6.19663V33.804C0.25 37.0816 2.97627 39.75 6.35237 39.75H34.6475C38.0239 39.75 40.7498 37.0816 40.7498 33.804Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0005 8.10213V19.3553C40.7781 19.4084 40.5659 19.4651 40.3584 19.5322C33.0586 21.9184 27.6969 26.4979 24.5249 33.3266C23.9063 34.6568 23.5217 36.1598 23.3377 37.6529C23.2765 38.1638 23.2374 38.6735 23.2207 39.1738C23.2112 39.4489 23.204 39.7249 23.1969 40H10.7969V30.4423C10.8183 30.4595 10.8421 30.4768 10.8632 30.494V1.47715H10.7969V0.000331879H23.3377V1.29898H23.2952V16.8061C23.3095 16.7945 23.3238 16.7819 23.3377 16.7703C28.5923 12.3086 34.4175 9.55705 41.0005 8.10213Z",
    fill: "#FFE081"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3377 40V37.6529V16.7703V1.29898V0H10.7969V1.47716V30.442V40H23.1969H23.3377Z",
    fill: "#8DDCA4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0c726aa554cd97275265e7f6450e22c6.svg";
export { ForwardRef as ReactComponent };